const formatKg = (value) => `${Number(value || 0).toLocaleString("de-DE")} kg`;
const formatCbm = (value) => `${Number(value || 0).toLocaleString("de-DE")} m3`;

export default function TariffBreakdownTable({ result }) {
  if (!result?.breakdown) {
    return null;
  }

  const { breakdown } = result;
  const rows = [
    ["Tarifart", result.tariff?.tariffTypeLabel || "-"],
    ["PLZ-Zone", breakdown.zone ? `PLZ ${breakdown.postalPrefix} = Zone ${breakdown.zone}` : "-"],
    [
      "Volumen",
      `${Number(breakdown.cbmPerPallet || 0).toLocaleString("de-DE")} m3 je Palette x ${breakdown.palletCount || 0} = ${formatCbm(breakdown.totalCbm)}`,
    ],
    [
      "Volumengewicht",
      `${formatCbm(breakdown.totalCbm)} x 150 kg = ${formatKg(breakdown.volumetricWeightKg)}`,
    ],
    [
      "Packmittel-Mindestgewicht",
      `${breakdown.palletCount || 0} x ${formatKg(breakdown.packageMinimumWeightPerUnitKg)} = ${formatKg(breakdown.packageMinimumWeightKg)}`,
    ],
    ["Tatsaechliches Gewicht", formatKg(breakdown.actualWeightKg)],
    ["Frachtpflichtiges Gewicht", formatKg(breakdown.chargeableWeightKg)],
    ["Gewichtsstufe", breakdown.weightBreakKg ? formatKg(breakdown.weightBreakKg) : "Tarif auf Anfrage"],
    ["Warenwert", breakdown.goodsValue ? Number(breakdown.goodsValue).toLocaleString("de-DE", { style: "currency", currency: "EUR" }) : "-"],
    ["Entfernung", breakdown.distanceKm ? `${Number(breakdown.distanceKm).toLocaleString("de-DE")} km` : "-"],
  ];

  return (
    <div className="table-wrap tariff-breakdown-wrap">
      <table className="data-table tariff-breakdown-table">
        <thead>
          <tr>
            <th>Schritt</th>
            <th>Berechnung</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(([label, value]) => (
            <tr key={label}>
              <td>{label}</td>
              <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

